/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/qaPhonePage.ts
 * FILE_ID: JOBHUB-QA-PHONE-PAGE-001
 * PURPOSE: Phone QA is Set Up or the checklist. One page, chosen once.
 */
export type QaPhonePage = 'setup' | 'qa'

export function requestQaPhonePage(page: QaPhonePage, afterCreate = false) {
  window.dispatchEvent(new CustomEvent('qa-phone-page', { detail: { page, afterCreate } }))
}

export function initialQaPhonePage(input: {
  inspectionsSettled: boolean
  inspectionCount: number
  areasFetching: boolean
  areasSettled: boolean
  areaCount: number
}): 'loading' | QaPhonePage {
  if (!input.inspectionsSettled) return 'loading'
  return 'qa'
}

export function qaPhoneVisiblePage(
  _openSetup: boolean,
  chosen: QaPhonePage | null,
  auto: 'loading' | QaPhonePage,
): QaPhonePage | null {
  if (chosen) return chosen
  return auto === 'loading' ? null : auto
}
